import Vue from 'vue'
import Router from 'vue-router'
import her2 from '../components/her2.vue'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'her2',
      component: her2
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js